import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageFeedbackStyles = makeStyles({
  feedbackText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  },

  authorCell: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexWrap: "nowrap",
  },

  authorName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
